import {share} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {getMessageFromException} from '../utilities/Util';
import {NotificationService} from './NotificationService';
import {CompanyCategoryType, Company, CompanyClient, DuplicateCompanyCheckResponse, PagedListOfCompany} from './api.client';
import {Observable} from 'rxjs';

// 003-retire-ngrx (US3): the company slice went component-local. All
// consumers are company-scoped pages that refetch per navigation, and the
// detail page already fetches by :id from the route (the deep-link path), so
// the list->detail store handoff only saved one GET. Methods return the API
// observable; the components hold the data.
@Injectable()
export class CompanyService {

    constructor(private _companyApiService: CompanyClient,
                private _notificationService: NotificationService) {
    }

    // getCompanies
    getCompanies(searchValue: string,
                 region: string,
                 category: CompanyCategoryType[] | null | undefined,
                 includeDisabled: boolean,
                 sortName: string,
                 descending: boolean,
                 limit: number,
                 offset: number): Observable<PagedListOfCompany> {
        if (!category || category.length === 0) {
            category = [];
        }
        const request = this._companyApiService.retrieveCompaniesPaged(
            searchValue,
            region,
            includeDisabled,
            category,
            limit || 10,
            offset || 0,
            sortName || 'Name',
            null,
            descending
        ).pipe(share());
        request.subscribe({
            next: () => {
            }, error: () => {
                this._notificationService.showError('Error Loading Companies');
            }, complete: () => {

            }
        });
        return request;
    }

    addCompany(company: Company): Observable<Company> {
        const request = this._companyApiService.addCompany(company).pipe(share());
        this._notificationService.showSuccess('Attempting to save new Company.');
        request.subscribe({
            next: () => {
                this._notificationService.showSuccess('Company Successfully Created!');
            }, error: (err) => {
                this._notificationService.showError(getMessageFromException(err));
            }, complete: () => {

            }
        });
        return request;
    }

    updateCompany(company: Company): Observable<Company> {
        const request = this._companyApiService.updateCompany(company).pipe(share());
        this._notificationService.showSuccess('Attempting to update Company.');
        request.subscribe({
            next: () => {
                this._notificationService.showSuccess('Company Succesfully Updated!');
            }, error: () => {
                this._notificationService.showError('There was a problem updating this Company.');
            }, complete: () => {

            }
        });
        return request;
    }

    deleteCompany(id: string): Observable<boolean> {
        const request = this._companyApiService.deleteCompany(id).pipe(share());
        this._notificationService.showSuccess('Attempting to delete Company.');
        request.subscribe({
            next: () => {
                this._notificationService.showSuccess('Company Successfully Deleted!');
            }, error: (err) => {
                this._notificationService.showError(getMessageFromException(err));
            }, complete: () => {

            }
        });

        return request;
    }

    getCompanyById(id: string): Observable<Company> {
        const request = this._companyApiService.retrieveCompany(id).pipe(share());
        request.subscribe({
            next: () => {
            }, error: () => {
                this._notificationService.showError('There was a problem retrieving the selected company.');
            }, complete: () => {

            }
        });
        return request;
    }

    public checkDuplicateCompany(name: string, address: string): Observable<DuplicateCompanyCheckResponse> {
        return this._companyApiService.checkDuplicateCompany(name, address).pipe(share());
    }
}
